import {apiAction} from './helper';

export const GET_SERVICE_STATUS = apiAction('GET_SERVICE_STATUS');
export const START_SERVICE = apiAction('START_SERVICE');
export const STOP_SERVICE = apiAction('STOP_SERVICE');
export const RESTART_SERVICE = apiAction('RESTART_SERVICE');
export const GET_SERVICE_IS_NEWER = apiAction('GET_SERVICE_IS_NEWER');
